import { ActionTypesInvoicings } from './constants';
import { InvoicingDirectory, InvoicingFile, InvoicingInitialStateType } from './types';

const initialState: InvoicingInitialStateType = {
  invoicingDirectoryList: [] as InvoicingDirectory[],
  currentInvoicingDirectory: '',
  invoicingData: [] as InvoicingFile[],
  totalFiles: 0,
  selectedInvoiceDownloadItems: [] as string[],
  isInvoicingDataLoading: false,
  isInvoicingDirectoryListLoading: false,
  clientTypeData: [],
  isClientTypeDataLoading: false,
  isInvoiceUploadLoading: false,
  isInvoiceDeleteLoading: false,
};

function invoicingReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypesInvoicings.SET_INVOICING_DIRECTORY_LIST:
      return {
        ...state,
        invoicingDirectoryList: action.invoicingDirectoryData,
      };
    case ActionTypesInvoicings.SET_CURRENT_INVOICING_DIRECTORY:
      return {
        ...state,
        currentInvoicingDirectory: action.folderName,
      };
    case ActionTypesInvoicings.SET_INVOICING_DATA:
      return {
        ...state,
        invoicingData: action.gridData,
      };
    case ActionTypesInvoicings.SET_INVOICING_TOTAL_FILES:
      return {
        ...state,
        totalFiles: action.totalFiles,
      };
    case ActionTypesInvoicings.TOGGLE_IS_INVOICING_DIRECTORY_LIST_LOADING:
      return {
        ...state,
        isInvoicingDirectoryListLoading: action.isLoading,
      };
    case ActionTypesInvoicings.TOGGLE_IS_INVOICING_DATA_LOADING:
      return {
        ...state,
        isInvoicingDataLoading: action.isLoading,
      };
    case ActionTypesInvoicings.SET_CLIENT_TYPE_INVOICE_DATA:
      return {
        ...state,
        clientTypeData: action.gridData,
      };
    case ActionTypesInvoicings.TOGGLE_IS_CLIENT_TYPE_DATA_LOADING:
      return {
        ...state,
        isClientTypeDataLoading: action.isLoading,
      };
    case ActionTypesInvoicings.TOGGLE_IS_INVOICE_UPLOAD_LOADING:
      return {
        ...state,
        isInvoiceUploadLoading: action.isLoading,
      };
    case ActionTypesInvoicings.TOGGLE_IS_INVOICE_DELETE_LOADING:
      return {
        ...state,
        isInvoiceDeleteLoading: action.isLoading,
      };

    default:
      return state;
  }
}

export default invoicingReducer;
